import Element from 'ui/Element';
import HiddenCollapsedMixin from './mixins/HiddenCollapsedMixin';
import ClickableMixin from './mixins/ClickableMixin';
import LinkableMixin from './mixins/LinkableMixin';
import mixin from 'privates/utils/mixin';
/**
 * @class Shape
 * @summary A simple shape.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.LinkableMixin
 * @mixes $w.ClickableMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.svgshape.SvgShape
 * @viewername wysiwyg.viewer.components.VectorImage
 * @tagname shape
 */
class Shape extends Element {
    constructor(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        super(RMI, compId, contextId, wixSelector, controllerId, role, type);
        mixin(Shape.prototype, HiddenCollapsedMixin.prototype);
        mixin(Shape.prototype, LinkableMixin.prototype);
        mixin(Shape.prototype, ClickableMixin.prototype);
    }
}

export default Shape;



// WEBPACK FOOTER //
// ./js/modules/ui/Shape.es6